import I18n from 'I18n';
import { useCallback } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { VALUES } from 'automation-ui-enrollment/constants/scheduledEnrollment/ExpressionTypes';
import { MONTHLY } from 'automation-ui-enrollment/constants/scheduledEnrollment/ScheduleCadence';
import { DayOfMonthFlexValues, DayOfMonthSpecificDayValues } from 'automation-ui-enrollment/constants/scheduledEnrollment/DayOfMonthValues';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DayOfMonthSelect = ({
  schedule,
  onChange,
  selectProps = {},
  readOnly
}) => {
  var _schedule$getDayOfMon;
  const handleSpecificDaysChange = useCallback(({
    target: {
      value: values
    }
  }) => {
    /* expected type of `value` is an array so renamed to values */
    onChange(syntheticEvent(schedule.setDayOfMonthValues(values)));
  }, [onChange, schedule]);
  const handleFlexDaysChange = useCallback(({
    target: {
      value
    }
  }) => {
    // Look up the schedule updater for the chosen flex value
    const flexValueOptions = schedule.getDayOfMonthFlexValueOptions();
    onChange(syntheticEvent(flexValueOptions[value].scheduleUpdater(schedule)));
  }, [onChange, schedule]);
  const dayOfMonthExpression = schedule.dayOfMonth.expressionType;
  const dayOfMonthValues = [...((_schedule$getDayOfMon = schedule.getDayOfMonthValues()) !== null && _schedule$getDayOfMon !== void 0 ? _schedule$getDayOfMon : [])];
  const isFlex = dayOfMonthExpression !== VALUES;

  /* this component only works with monthly schedules */
  if (schedule.getCadence() !== MONTHLY) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIToggleGroup, {
      name: "inline-example",
      className: "m-bottom-2",
      children: [/*#__PURE__*/_jsx(UIRadioInput, {
        checked: !isFlex,
        inline: true,
        onChange: () => {
          handleSpecificDaysChange(syntheticEvent([]));
        },
        readOnly: readOnly,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.specificDays.label"
        })
      }), /*#__PURE__*/_jsx(UIRadioInput, {
        checked: isFlex,
        inline: true,
        onChange: () => {
          handleFlexDaysChange(syntheticEvent(DayOfMonthFlexValues.ON_LAST_DAY.id));
        },
        readOnly: readOnly,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.flexDays.label"
        })
      })]
    }), !isFlex && /*#__PURE__*/_jsx(UISelect, Object.assign({}, selectProps, {
      "data-test-id": "select-schedule-day-of-month",
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.dayOfMonth.placeholder"
      }),
      multi: true,
      value: dayOfMonthValues.sort(),
      onChange: handleSpecificDaysChange,
      options: Object.values(DayOfMonthSpecificDayValues).map(value => {
        return {
          text: `${value}`,
          value
        };
      }),
      readOnly: readOnly
    })), isFlex && /*#__PURE__*/_jsx(UISelect, Object.assign({}, selectProps, {
      "data-test-id": "select-schedule-day-of-month-flex",
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.dayOfMonth.placeholder"
      }),
      value: schedule.getDayOfMonthFlexValue(),
      onChange: handleFlexDaysChange,
      options: Object.keys(DayOfMonthFlexValues).map(valueKey => {
        return {
          text: I18n.text(DayOfMonthFlexValues[valueKey].labelKey),
          value: valueKey
        };
      }),
      readOnly: readOnly
    }))]
  });
};
export default DayOfMonthSelect;